import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import {
  ModernModalBackdrop,
  ModernVerticalModal,
  ModalFieldGroup,
  ModalLabel,
  ModalInput,
  ModalSelect,
  SubmitButton,
} from '../../../styles/Modal'
import { IoCloseCircleSharp, IoArrowBack } from 'react-icons/io5'
import { TbUserDollar } from 'react-icons/tb'
import { carregarDistribuidores } from '../../../services/dists'

interface PropsGestor {
  name: string
  setName: (text: string) => void
  email: string
  setEmail: (text: string) => void
  password: string
  setPassword: (text: string) => void
  nickname: string
  setNickname: (text: string) => void
  phone: string
  setPhone: (text: string) => void
  role: string
  setRole: (text: string) => void
  loading: boolean
  handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleClick: () => void
  setCloseModal: () => void
  handleBack?: () => void
  distGestor?: number | string
  setDistGestor?: (distId: any) => void
}

function ModalGestor({
  email,
  password,
  name,
  nickname,
  phone,
  loading,
  setName,
  setEmail,
  setPassword,
  setNickname,
  handlePhoneChange,
  handleClick,
  setCloseModal,
  handleBack,
  distGestor,
  setDistGestor,
}: PropsGestor) {
  const [distsList, setDistsList] = useState<any[]>([])

  useEffect(() => {
    carregarDistribuidores().then((res) => {
      setDistsList(res)
    })
  }, [])

  const handleGeneratePassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*'
    let newPassword = ''

    for (let i = 0; i < 12; i++) {
      newPassword += chars.charAt(Math.floor(Math.random() * chars.length))
    }

    setPassword(newPassword)
    navigator.clipboard.writeText(newPassword)
    toast.success('Senha gerada e copiada para a área de transferência!')
  }

  return (
    <ModernModalBackdrop>
      <ModernVerticalModal style={{ maxWidth: '520px' }}>
        <div className="header">
          {handleBack && (
            <button className="btn-back" onClick={handleBack} type="button">
              <IoArrowBack />
            </button>
          )}
          <h3>Cadastro de Gestor Comercial</h3>
          <button className="btn-close" onClick={setCloseModal} type="button">
            <IoCloseCircleSharp />
          </button>
        </div>

        <div className="body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
          {/* Card Didático Explicativo */}
          <div
            style={{
              background: 'linear-gradient(135deg, rgba(2, 132, 199, 0.12), rgba(30, 58, 138, 0.12))',
              border: '1px solid rgba(56, 189, 248, 0.25)',
              borderRadius: '12px',
              padding: '14px 16px',
              display: 'flex',
              gap: '12px',
              alignItems: 'flex-start',
            }}
          >
            <TbUserDollar style={{ fontSize: '26px', color: '#38bdf8', flexShrink: 0, marginTop: '2px' }} />
            <div style={{ fontSize: '12px', color: '#cbd5e1', lineHeight: '1.5' }}>
              <strong style={{ color: '#ffffff', display: 'block', marginBottom: '2px', fontSize: '13px' }}>
                Perfil Gestor Comercial (Apenas o distribuidor dele)
              </strong>
              O gestor é o responsável comercial direto pela sua unidade. Ele acompanha sellout, positivação, estoque e metas de vendas exclusivamente do distribuidor vinculado.
            </div>
          </div>

          {/* Vínculo de Distribuidor Único */}
          <ModalFieldGroup>
            <ModalLabel>Distribuidor Vinculado *</ModalLabel>
            <ModalSelect
              value={distGestor || ''}
              onChange={(e) => setDistGestor && setDistGestor(e.target.value ? Number(e.target.value) : '')}
            >
              <option value="">Selecione o Distribuidor deste Gestor</option>
              {distsList.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name || d.fantasy_name} {d.cnpj ? `(CNPJ: ${d.cnpj})` : ''}
                </option>
              ))}
            </ModalSelect>
            <span style={{ fontSize: '11px', color: '#94a3b8' }}>
              O gestor terá acesso estritamente aos relatórios deste distribuidor.
            </span>
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Usuário (Login) *</ModalLabel>
            <ModalInput
              type="text"
              value={nickname}
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, '')
                setNickname(value)
              }}
              placeholder="Digite o login de acesso"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Nome Completo *</ModalLabel>
            <ModalInput
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Digite o nome completo"
              style={{ textTransform: 'capitalize' }}
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Senha *</ModalLabel>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <ModalInput
                type="text"
                value={password}
                placeholder="Gerar senha ou digitar"
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: '100%', paddingRight: '120px' }}
              />
              <button
                type="button"
                onClick={handleGeneratePassword}
                style={{
                  position: 'absolute',
                  right: '8px',
                  background: '#0284c7',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '11px',
                  padding: '6px 12px',
                  color: '#ffffff',
                  fontWeight: 600,
                }}
              >
                Gerar & Copiar
              </button>
            </div>
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>E-mail *</ModalLabel>
            <ModalInput
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ex: gestor@grupogsa.com.br"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Telefone *</ModalLabel>
            <ModalInput
              type="text"
              value={phone}
              onChange={handlePhoneChange}
              maxLength={15}
              placeholder="(00) 00000-0000"
            />
          </ModalFieldGroup>

          <SubmitButton type="button" onClick={handleClick} disabled={loading}>
            {loading ? 'Carregando...' : 'Criar Gestor'}
          </SubmitButton>
        </div>
      </ModernVerticalModal>
    </ModernModalBackdrop>
  )
}

export default ModalGestor
